<script setup>
import { ref, defineExpose, defineEmits } from 'vue'
import { ElMessage } from 'element-plus'

const emit = defineEmits(['confirm'])

const visible = ref(false)
const scannerList = ref([])
const scannerId = ref('')

const open = (list) => {
  visible.value = true
  scannerList.value = list
}

const confirm = () => {
  if (!scannerId.value) {
    ElMessage.error('请选择扫描仪')
    return
  }
  visible.value = false
  emit('confirm', scannerId.value)
}

const close = () => {
  visible.value = false
}

defineExpose({
  open
})
</script>

<template>
  <el-dialog v-model="visible" append-to-body :show-close="false" width="564">
    <template #header>
      <div class="choose-scanner-title">
        <span>选择扫描仪</span>
        <el-icon @click="close" size="18" color="#D8D7D7" style="cursor:pointer;">
          <Close />
        </el-icon>
      </div>
    </template>
    <div class="choose-scanner-content">
      <el-radio-group v-model="scannerId">
        <el-radio v-for="item in scannerList" :key="item.approvingId" :label="item.scannerName" :value="item.approvingId" />
      </el-radio-group>
    </div>
    <div class="foot-btn">
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped lang='scss'>
.choose-scanner-title {
  height: 35px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  border-bottom: solid 1px #E6E6E6;
}
.choose-scanner-content {
  max-height: 300px;
  overflow: auto;
  .el-radio-group {
    flex-direction: column;
    align-items: flex-start;
  }
}
.foot-btn {
  height: 30px;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
}
</style>
